export default __webpack_public_path__ + "static/media/icone_upload.deb6d299.svg";